var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.552 0.169836C14.1674 -0.0351275 14.8326 -0.0351275 15.448 0.169836L26.5 3.85384L37.078 0.327836C37.4688 0.197611 37.8849 0.162094 38.2921 0.224211C38.6993 0.286329 39.0859 0.444302 39.4201 0.685118C39.7542 0.925934 40.0264 1.2427 40.2142 1.60932C40.4019 1.97595 40.4999 2.38193 40.5 2.79384V29.2418C40.4999 29.8716 40.3017 30.4853 39.9334 30.9961C39.5651 31.5069 39.0455 31.8888 38.448 32.0878L27.448 35.7538C26.832 35.9598 26.168 35.9598 25.552 35.7538L14.5 32.0698L3.922 35.5958C3.53122 35.7261 3.1151 35.7616 2.70791 35.6995C2.30071 35.6373 1.9141 35.4794 1.57993 35.2386C1.24576 34.9977 0.973581 34.681 0.785823 34.3143C0.598066 33.9477 0.500101 33.5417 0.5 33.1298V6.68184C0.500058 6.05211 0.698275 5.43837 1.06657 4.92758C1.43486 4.41678 1.95454 4.03483 2.552 3.83584L13.552 0.169836ZM12.5 28.5218V4.73584L4.5 7.40384V31.1878L12.5 28.5198V28.5218ZM16.5 4.73784V28.5218L24.5 31.1898V7.40183L16.5 4.73384V4.73784ZM28.5 7.40584V31.1898L36.5 28.5218V4.73584L28.5 7.40584Z",
    fill: "#DED2CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapViewIcon);
export default __webpack_public_path__ + "static/media/map-view_icon.e19adf9d3d449a9e3f42d5f0575ed611.svg";
export { ForwardRef as ReactComponent };